"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SecurePay = void 0;
var react_1 = __importStar(require("react"));
exports.SecurePay = (0, react_1.forwardRef)(function (args, ref) {
    var _a = args.containerId, containerId = _a === void 0 ? 'securepay-ui-container' : _a, _b = args.scriptId, scriptId = _b === void 0 ? 'securepay-ui-js' : _b, props = __rest(args, ["containerId", "scriptId"]);
    var _c = (0, react_1.useState)(), api = _c[0], setApi = _c[1];
    (0, react_1.useImperativeHandle)(ref, function () { return ({
        tokenise: function () {
            if (api)
                api.tokenise();
        },
        reset: function () {
            if (api) {
                api.reset();
            }
        },
    }); });
    var init = function () {
        var temp = new window.securePayUI.init({
            containerId: containerId,
            scriptId: scriptId,
            clientId: props.clientId,
            merchantCode: props.merchantCode,
            card: {
                allowedCardTypes: ['visa', 'mastercard'],
                showCardIcons: true,
                onTokeniseSuccess: function (tokenisedCard) {
                    props.onTokeniseSuccess && props.onTokeniseSuccess(tokenisedCard);
                },
                onTokeniseError: function (errorResponse) {
                    var response = JSON.parse(errorResponse);
                    props.onTokeniseError && props.onTokeniseError(response.errors);
                },
            },
            style: {
                backgroundColor: props.backGroundColor ? props.backGroundColor : '#f9f9f9',
                label: {
                    font: {
                        family: '-apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
                        size: '1rem',
                        color: '#313131',
                    },
                },
                input: {
                    font: {
                        family: '-apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
                        size: '1rem',
                        color: '#313131',
                    },
                },
            },
            onLoadComplete: function () {
                props.onLoadComplete && props.onLoadComplete();
            },
        });
        setApi(temp);
    };
    (0, react_1.useEffect)(function () {
        var existingScript = document.getElementById(scriptId);
        if (!existingScript) {
            var script = document.createElement('script');
            script.src = props.uri;
            script.id = scriptId;
            document.body.appendChild(script);
            script.onload = function () {
                init();
            };
        }
        else {
            init();
        }
    }, []);
    return react_1.default.createElement("div", { id: containerId });
});
//# sourceMappingURL=SecurePay.js.map